import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "department-history",
  components: {
    AppHeader
  },
  created() {
    this.getUser();
    this.getDepartmentHistory();
  },
  data() {
    return {
      getDepartmentHistoryEnd: false,
      departmentHistories: [],
      errorInfo: "",
      user: ""
    };
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    async getDepartmentHistory() {
      this.getDepartmentHistoryEnd = false;
      let data = {
        user_id: this.$route.params.user_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT_HISTORY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departmentHistories = res.department_histories;
      this.getDepartmentHistoryEnd = true;
    },
    deleteModal(departmentHistoryId) {
      this.cancelDepartmentHistoryId = departmentHistoryId;
      this.$bvModal.show("modal-delete");
    },
    async cancelDepartmentHistory() {
      let res = await this.$store
        .dispatch("DELETE_DEPARTMENT_HISTORY", {
          id: this.cancelDepartmentHistoryId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getDepartmentHistory();
      } else {
        this.errorInfo = res.error;
      }
      this.$bvModal.hide("modal-delete");
    },
    authorityCheck() {
      if (localStorage.user_authority == 2) {
        // 役員でログイン
        return false;
      }
      return true;
    },
    formatDate(date) {
      return dayjs(date).format("YYYY年MM月DD日");
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goDepartmentHistoryNew() {
      this.$router.push({
        path: `/department_history/${this.$route.params.user_id}/new`
      });
    },
    goDepartmentHistoryForceEdit() {
      this.$router.push({
        path: `/department_history/${this.$route.params.user_id}/force_edit`
      });
    },
    afterRelease(date) {
      if (dayjs(date).format("YYYY-MM-DD") <= "2020-04-01") {
        return false;
      } else {
        return true;
      }
    }
  }
};
